"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountWebSocket = void 0;
const BaseWebSocket_1 = require("./BaseWebSocket");
const TradeAPILib_1 = require("TradeAPILib");
const rxjs_1 = require("rxjs");
const trade_utils_lib_1 = require("trade_utils_lib");
const operators_1 = require("rxjs/operators");
class AccountWebSocket extends BaseWebSocket_1.BaseWebSocket {
    getDataObservableImpl() {
        return (0, trade_utils_lib_1.requestWithRetry)(() => {
            console.log("open account websocket");
            return (0, trade_utils_lib_1.getTradeDependencyInstance)().getAccessToken()
                .pipe((0, operators_1.flatMap)(token => {
                var _a;
                let url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().accountWebSocketHost}/user?channel=balance&tk=${token}`;
                if ((_a = this.webSocketConfig) === null || _a === void 0 ? void 0 : _a.exchange) {
                    url = `${url}&exchange=${this.webSocketConfig.exchange}`;
                }
                return this.getWebSocketSubject(url);
            }))
                .pipe((0, operators_1.flatMap)((result) => {
                if (!result) {
                    return rxjs_1.NEVER;
                }
                const type = result.channel;
                if (!type) {
                    return rxjs_1.NEVER;
                }
                let pushResult = {};
                switch (type) {
                    case BaseWebSocket_1.SubscribeType.exchangeOrder:
                        pushResult.exchangeOrder = TradeAPILib_1.TradeUtils.convertToExchangeOrder(result.data);
                        break;
                    case BaseWebSocket_1.SubscribeType.botOrder:
                        pushResult.botOrder = TradeAPILib_1.TradeUtils.convertToExchangeOrder(result.data);
                        break;
                    case BaseWebSocket_1.SubscribeType.balance:
                        pushResult.balance = this.parseBalanceData(result.data);
                }
                if (pushResult.balance || pushResult.botOrder || pushResult.exchangeOrder) {
                    return (0, rxjs_1.of)(pushResult);
                }
                return rxjs_1.NEVER;
            }));
        }, { name: "AccountWebSocket" });
    }
    reportState() {
    }
    parseBalanceData(data) {
        let result = {
            tradeBalance: undefined,
            debtBalance: undefined
        };
        if ("balance" in data) {
            result.tradeBalance = data.balance.map(item => {
                return {
                    balanceType: TradeAPILib_1.BALANCE_TYPE.TRADE,
                    currency: item.coin,
                    available: item.free,
                    frozen: item.frozen,
                    balance: item.free + item.frozen,
                    fullName: "",
                    btcPrice: 0,
                    btcChangePercent: 0,
                    usdPrice: 0,
                    usdChangePercent: 0
                };
            });
        }
        if ("loan" in data) {
            result.debtBalance = data.loan.map(item => {
                return {
                    currency: item.coin,
                    total: item.principal + item.interest,
                    principal: item.principal,
                    interest: item.interest,
                    fullName: "",
                    btcPrice: 0,
                    btcChangePercent: 0,
                    usdPrice: 0,
                    usdChangePercent: 0
                };
            });
        }
        return result;
    }
    getExchangeOrderObservable() {
        return this.getMulticastSubject()
            .pipe((0, operators_1.takeWhile)(item => item.exchangeOrder !== undefined))
            .pipe((0, operators_1.map)(result => {
            return result.exchangeOrder;
        }));
    }
    getBotOrderObservable() {
        return this.getMulticastSubject()
            .pipe((0, operators_1.takeWhile)(item => item.botOrder !== undefined))
            .pipe((0, operators_1.map)(result => {
            return result.botOrder;
        }));
    }
    getBalancePushObservable() {
        return this.getMulticastSubject()
            .pipe((0, operators_1.takeWhile)(item => item.balance !== undefined))
            .pipe((0, operators_1.map)(result => {
            return result.balance;
        }));
    }
}
exports.AccountWebSocket = AccountWebSocket;
